export type Tone = "primary" | "accent" | "secondary" | "foreground";

export const chipTone: Record<Tone, string> = {
  primary: "bg-primary-100 text-primary-900 ring-1 ring-inset ring-primary-200",
  accent: "bg-accent-100 text-accent-900 ring-1 ring-inset ring-accent-200",
  secondary:
    "bg-secondary-100 text-secondary-900 ring-1 ring-inset ring-secondary-200",
  foreground: "bg-foreground-100 text-foreground-800 ring-1 ring-inset ring-foreground-200",
};

export const solidTone: Record<Tone, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-foreground-950",
  secondary: "bg-secondary-600 text-background-50",
  foreground: "bg-foreground-950 text-background-50",
};

export const dotTone: Record<Tone, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
  foreground: "bg-foreground-500",
};

export const barTone: Record<Tone, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-400",
  secondary: "bg-secondary-300",
  foreground: "bg-foreground-700",
};

export const textTone: Record<Tone, string> = {
  primary: "text-primary-700",
  accent: "text-accent-700",
  secondary: "text-secondary-700",
  foreground: "text-foreground-700",
};